import React from 'react';
import { Button } from './ui/button';
import { Award, GraduationCap, Users, Sparkles, ArrowRight } from 'lucide-react';

const PRACHI_PHOTOS = {
  standing: 'https://customer-assets-jt897jd0.emergentagent.net/job_prachi-premium/artifacts/tqofaxeh_IMG_9848.JPG.webp',
  orange: 'https://customer-assets-jt897jd0.emergentagent.net/job_prachi-premium/artifacts/3v768xiy_IMG_9902.JPG.webp',
  sign: 'https://customer-assets-jt897jd0.emergentagent.net/job_prachi-premium/artifacts/918k476o_IMG_9890.JPG.webp',
  pinkChair: 'https://customer-assets-jt897jd0.emergentagent.net/job_prachi-premium/artifacts/crhf8376_IMG_9885.JPG.webp',
  leaning: 'https://customer-assets-jt897jd0.emergentagent.net/job_prachi-premium/artifacts/vrctfwoh_IMG_9958.JPG.webp',
};

const stats = [
  { icon: Users, value: '10,000+', label: 'Transformations' },
  { icon: GraduationCap, value: '12+ yrs', label: 'Clinical practice' },
  { icon: Award, value: '4.9 ★', label: 'Rated by clients' },
  { icon: Sparkles, value: '4', label: 'Countries served' },
];

const About = ({ onBook }) => {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute -left-32 top-40 w-[400px] h-[400px] rounded-full bg-[#e8f2e2] opacity-40 blur-3xl" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Photo collage */}
          <div className="relative h-[620px] hidden lg:block">
            <div className="absolute top-0 left-0 w-56 h-72 rounded-3xl overflow-hidden shadow-xl rotate-[-4deg] hover:rotate-0 transition-transform duration-500">
              <img src={PRACHI_PHOTOS.sign} alt="Prachi at NutrifyMe clinic" className="w-full h-full object-cover" />
            </div>
            <div className="absolute top-16 right-4 w-64 h-80 rounded-3xl overflow-hidden shadow-2xl rotate-[3deg] hover:rotate-0 transition-transform duration-500 z-10">
              <img src={PRACHI_PHOTOS.orange} alt="Dietitian Prachi tossing an orange" className="w-full h-full object-cover" />
            </div>
            <div className="absolute bottom-8 left-16 w-72 h-72 rounded-3xl overflow-hidden shadow-xl rotate-[2deg] hover:rotate-0 transition-transform duration-500">
              <img src={PRACHI_PHOTOS.pinkChair} alt="Prachi seated portrait" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-4 right-24 w-52 h-64 rounded-3xl overflow-hidden shadow-xl rotate-[-3deg] hover:rotate-0 transition-transform duration-500 z-20">
              <img src={PRACHI_PHOTOS.leaning} alt="Dietitian Prachi leaning" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Mobile fallback: single hero photo */}
          <div className="lg:hidden">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img src={PRACHI_PHOTOS.pinkChair} alt="Dietitian Prachi" className="w-full h-[420px] object-cover" />
            </div>
          </div>

          {/* Copy */}
          <div>
            <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Meet the founder</div>
            <h2 className="font-serif text-4xl lg:text-5xl text-[#1a2b17] leading-[1.1] tracking-tight">
              I&apos;m <span className="italic text-[#c9743a] font-light">Prachi</span> —<br /> your dietitian, not another influencer.
            </h2>
            <p className="mt-6 text-lg text-[#4a5544] leading-relaxed">
              After a decade in clinical nutrition, I started NutrifyMe because most Indian women deserved better than crash diets and copy-paste plans.
              Every plan I write blends modern nutrition science with the food you actually grew up eating.
            </p>
            <p className="mt-4 text-[#4a5544] leading-relaxed">
              Whether it&apos;s PCOS, stubborn belly fat, gut issues or just the itch to feel like yourself again — you&apos;ll get a plan built for your body, culture and calendar.
            </p>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((s, i) => (
                <div key={i} className="p-4 rounded-2xl bg-[#faf7f1] text-center">
                  <s.icon className="w-5 h-5 text-[#3a5a2c] mx-auto" />
                  <div className="mt-2 font-serif text-xl text-[#1a2b17]">{s.value}</div>
                  <div className="text-[10px] tracking-widest uppercase text-[#7a8471] mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-9 flex flex-wrap gap-3">
              <Button onClick={onBook} className="h-12 px-7 rounded-full bg-[#3a5a2c] hover:bg-[#2d4622] text-white">
                Book free consultation <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
              <Button variant="outline" onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} className="h-12 px-7 rounded-full">
                See all programs
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
export { PRACHI_PHOTOS };
